import styled from 'styled-components';

import { type ThemeTypes } from '../../../types/Theme.namespace';
import { type ListType } from './ListNative';

type ListSpacing = {
  markerSize: ThemeTypes.FontSize;
  markerColour: ThemeTypes.Colors;
  gap?: ThemeTypes.Spacing;
};

type ListItemProps = {
  listType: ListType;
  markerFontWeight: ThemeTypes.FontWeight;
};

const ListContainer = styled.ul<ListSpacing>`
  margin-left: ${({ theme }) => theme.spacing.M24};
  display: flex;
  flex-direction: column;
  gap: ${({ theme, gap }) => (gap ? theme.spacing[gap] : '')};
  ${({ theme, markerSize }) => theme.fontSize[markerSize]}
  color: ${({ theme, markerColour }) => theme.colors[markerColour]};
`;

const ListItem = styled.li<ListItemProps>`
  list-style-type: ${({ listType }) =>
    listType === 'ol' ? 'decimal' : 'disc'};

  ::marker {
    font-weight: ${({ markerFontWeight, theme }) =>
      markerFontWeight && theme.fontWeight[markerFontWeight]};
  }
`;

export { ListContainer, ListItem, type ListSpacing, type ListItemProps };
